import { Navigate, useLocation } from "react-router-dom";

import { useHubModuleHasAnyAccess } from "@/lib/useHubModuleWrite";

import { DeviceLookupPage } from "./DeviceLookupPage";

/**
 * Co-homed device lookup. Quality and manufacturing (including manufacturing management)
 * share the manufacturing report. `/quality/devices?label=` stays valid for existing links.
 */
export function DeviceLookupCoHomePage() {
  const location = useLocation();
  const hasManufacturing = useHubModuleHasAnyAccess("manufacturing");
  const hasManufacturingManagement = useHubModuleHasAnyAccess("manufacturing_management");
  const hasQuality = useHubModuleHasAnyAccess("quality");
  const onQuality = location.pathname.startsWith("/quality/");
  const hasManufacturingSide = hasManufacturing || hasManufacturingManagement;
  const hasCurrentHome = onQuality ? hasQuality : hasManufacturingSide;
  const hasOtherHome = onQuality ? hasManufacturingSide : hasQuality;
  if (!hasCurrentHome && hasOtherHome) {
    const target = onQuality ? "/manufacturing/device-lookup" : "/quality/devices";
    return <Navigate to={`${target}${location.search}`} replace />;
  }
  return <DeviceLookupPage />;
}
